import React from 'react';
import { IconProps } from '.';

const SvgArrowIndent = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M6.75 12.25h10.44l-3.72-3.72 1.06-1.06L20.06 13l-5.53 5.53-1.06-1.06 3.72-3.72H5.25V3h1.5v9.25Z'
      />
    </svg>
  );
};

export default SvgArrowIndent;
